<template>
  <div class="about-page">
    <Header />
    <div class="about container py-5">
      <div class="row justify-content-center">
        <div class="col-md-8 text-center">
          <div class="card shadow-sm border-0 p-5">
            <h1 class="fw-bold text-primary mb-4">About Zals Notes</h1>
            <p class="lead text-muted mb-4">
              A secure and simple space for the <b>Pandi Family</b> to store important notes, memories, and passwords.
            </p>
            <hr class="my-4">
            <p class="text-secondary small">
              Built with ❤️ using Vue.js 3 & Firebase.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'

export default {
  name: 'About',
  components: {
    Header
  }
}
</script>